import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import VerifyKicks from './pages/VerifyKicks.tsx';
import SkillzStore from './pages/SkillzStore.tsx';
import Bundles from './pages/Bundles.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';
import PasswordGate from './components/PasswordGate.tsx';
import './utils/posthog';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <PasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/verifykicks" element={<VerifyKicks />} />
            <Route path="/skillzstore" element={<SkillzStore />} />
            <Route path="/bundles" element={<Bundles />} />
          </Routes>
        </BrowserRouter>
      </PasswordGate>
    </ThemeProvider>
  </StrictMode>
);
